import { Alert, Divider, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import validator from "validator";
import { BootstrapDialog, BootstrapDialogTitle } from "../../components/BootstrapDialogTitle";
import { ColorButton } from "../../components/ColorButton";
import Item from "../../components/Item";
import AdminGridService from "./AdminGridService";
import FileSelectionComponent from "./FileSelectionComponent";

export default function GridUpload({ open, setOpen, handleSnackBar, callback }) {
    const [title, setTitle] = useState("");

    const [errTitle, setErrTitle] = useState(false);
    const [errFile, setErrFile] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => { }, []);

    const handleClose = () => {
        setTitle("");
        // setLetters("");
        setOpen(false);
    };

    const handleCreate = () => {
        let err = false;

        if (validator.isEmpty(title)) {
            err = true;
            setErrTitle(true);
        } else {
            setErrTitle(false);
        }

        if (!selectedFile) {
            err = true;
            setErrFile(true);
        } else {
            setErrFile(false);
        }

        if (err) {
            return;
        }

        AdminGridService.uploadImage(title, selectedFile)
            .then(() => {
                handleClose();
                if (handleSnackBar) {
                    handleSnackBar("info", "Puzzle uploaded successfully");
                }
                if (callback) {
                    callback();
                }
            })
            .catch((e) => {
                if (handleSnackBar) {
                    handleSnackBar("error", e.message || "Upload failed");
                }
            });
    };

    const handleFile = (file) => {
        setSelectedFile(file);
        setErrFile(false);
    };

    return (
        <div>
            <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="sm" fullWidth>
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Upload Puzzle Image
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Item>
                                    <Stack spacing={2}>
                                        <TextField
                                            id="txtTitle"
                                            label="Title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            error={errTitle}
                                            size="small"
                                        />
                                        <FileSelectionComponent handleFile={handleFile} error={errFile} />
                                        <Alert severity="info" sx={{ mt: 1 }}>
                                            System detects text using OCR and creates a puzzle automatically.
                                        </Alert>
                                    </Stack>
                                </Item>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Divider />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Item sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <ColorButton variant={"contained"} onClick={handleCreate}>
                                            Add
                                        </ColorButton>
                                    </Box>
                                </Item>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}

